/**
 * Humanizes an audit action constant for display, preferring the curated
 * `auditActions.<ACTION>` translation when one exists (215+ curated so far) and falling back
 * to a deterministic Title Case conversion for any action added later that hasn't been
 * translated yet - so nothing ever renders as a raw SCREAMING_SNAKE_CASE string.
 */
export function formatAuditAction(action, t) {
  if (!action) return "";
  const translated = t(`auditActions.${action}`);
  if (translated !== `auditActions.${action}`) return translated;
  return action.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatAuditModule(module, t) {
  if (!module) return "";
  return t(`auditModules.${module}`);
}
